var map = {
	"./1.png": 4148,
	"./2.png": 58,
	"./3.png": 3196,
	"./G1.png": 4108,
	"./GO.png": 4849,
	"./GO92X12.png": 1488,
	"./GOROUND2.png": 9067,
	"./Tailoringx-1.png": 7934,
	"./Tailoringx-2.png": 6691,
	"./WGLOGO.png": 9647,
	"./g2.png": 9072,
	"./ico.png": 3529,
	"./logo1.png": 3428,
	"./logo1234.png": 4506,
	"./logo3.png": 7029,
	"./profile.png": 7046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7080;